package org.chiangmeng.qfast.database

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Unit
import org.chiangmeng.qfast.database.shared.newInstance
import org.chiangmeng.qfast.database.shared.schema

public interface QFastDatabase : Transacter {
  public val queueHistoryQueries: QueueHistoryQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = QFastDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): QFastDatabase =
        QFastDatabase::class.newInstance(driver)
  }
}
